import { ReferenceEvent } from '@/enums';
import BaseModel from '../BaseModel';
import Researcher from '../Researcher';
import UploadEventPayload from './UploadEventPayload';
import DuplicateEventPayload from './DuplicateEventPayload';
import ScreeningEventPayload from './ScreeningEventPayload';
import FullTextReviewEventPayload from './FullTextReviewEventPayload';
import DataExtractionEventPayload from './DataExtractionEventPayload';
import CommentEventPayload from './CommentEventPayload';
import TagEventPayload from './TagEventPayload';
import FullTextPdfEventPayload from './FullTextPdfEventPayload';

export const REFERENCE_EVENT_TO_PAYLOAD_TYPE = {
  [ReferenceEvent.UPLOAD]: UploadEventPayload,
  [ReferenceEvent.DUPLICATE_STATE_UPDATE]: DuplicateEventPayload,
  [ReferenceEvent.SCREENING_VOTE_CREATE]: ScreeningEventPayload,
  [ReferenceEvent.SCREENING_VOTE_UPDATE]: ScreeningEventPayload,
  [ReferenceEvent.SCREENING_VOTE_CONFLICT]: ScreeningEventPayload,
  [ReferenceEvent.SCREENING_VOTE_REVOKE]: ScreeningEventPayload,
  [ReferenceEvent.SCREENING_OUTCOME_CREATE]: ScreeningEventPayload,
  [ReferenceEvent.SCREENING_OUTCOME_UPDATE]: ScreeningEventPayload,
  [ReferenceEvent.SCREENING_OUTCOME_REVOKE]: ScreeningEventPayload,
  [ReferenceEvent.FULL_TEXT_REVIEW_VOTE_CREATE]: FullTextReviewEventPayload,
  [ReferenceEvent.FULL_TEXT_REVIEW_VOTE_UPDATE]: FullTextReviewEventPayload,
  [ReferenceEvent.FULL_TEXT_REVIEW_VOTE_CONFLICT]: FullTextReviewEventPayload,
  [ReferenceEvent.FULL_TEXT_REVIEW_VOTE_REVOKE]: FullTextReviewEventPayload,
  [ReferenceEvent.FULL_TEXT_REVIEW_OUTCOME_CREATE]: FullTextReviewEventPayload,
  [ReferenceEvent.FULL_TEXT_REVIEW_OUTCOME_UPDATE]: FullTextReviewEventPayload,
  [ReferenceEvent.FULL_TEXT_REVIEW_OUTCOME_REVOKE]: FullTextReviewEventPayload,
  [ReferenceEvent.DATA_EXTRACTION_REPORT_PROPOSAL]: DataExtractionEventPayload,
  [ReferenceEvent.DATA_EXTRACTION_REPORT_ACCEPTED]: DataExtractionEventPayload,
  [ReferenceEvent.COMMENT_CREATE]: CommentEventPayload,
  [ReferenceEvent.COMMENT_EDIT]: CommentEventPayload,
  [ReferenceEvent.COMMENT_DELETE]: CommentEventPayload,
  [ReferenceEvent.TAG_ADD]: TagEventPayload,
  [ReferenceEvent.TAG_REMOVE]: TagEventPayload,
  [ReferenceEvent.FULL_TEXT_PDF_UPLOAD]: FullTextPdfEventPayload,
  [ReferenceEvent.FULL_TEXT_PDF_UPDATE]: FullTextPdfEventPayload,
  [ReferenceEvent.FULL_TEXT_PDF_DELETE]: FullTextPdfEventPayload,
  [ReferenceEvent.FULL_TEXT_PDF_FETCH_STARTED]: FullTextPdfEventPayload,
  [ReferenceEvent.FULL_TEXT_PDF_FETCH_NOT_FOUND]: FullTextPdfEventPayload,
  [ReferenceEvent.FULL_TEXT_PDF_FETCH_ERROR]: FullTextPdfEventPayload,
};

export default class ReferenceEventLog extends BaseModel {
  constructor(data = {}) {
    super(ReferenceEventLog, data);
    this.id = data.id;
    this.event = data.event;
    this.eventBy = data.eventBy && new Researcher(data.eventBy);
    this.payload =
      data.payload &&
      new REFERENCE_EVENT_TO_PAYLOAD_TYPE[data.event](
        data.payload,
        this
      );
    this.createdAt = data.createdAt && new Date(data.createdAt);
  }
}
